import { Router, type IRouter } from "express";
import { db, usersTable, dealsTable, accessRequestsTable, sellerLeadsTable, dealRoomsTable, bidsTable } from "@workspace/db";
import { count, sql } from "drizzle-orm";
import { requireAuth, requireRole } from "../middlewares/auth";

const router: IRouter = Router();

router.get("/admin/stats", requireAuth, requireRole("admin"), async (_req, res): Promise<void> => {
  const [dealStats] = await db
    .select({
      total: count(),
      pending: sql<number>`COUNT(*) FILTER (WHERE ${dealsTable.status} = 'pending')`.mapWith(Number),
      approved: sql<number>`COUNT(*) FILTER (WHERE ${dealsTable.status} = 'approved')`.mapWith(Number),
      rejected: sql<number>`COUNT(*) FILTER (WHERE ${dealsTable.status} = 'rejected')`.mapWith(Number),
    })
    .from(dealsTable);

  const [userStats] = await db
    .select({
      totalInvestors: sql<number>`COUNT(*) FILTER (WHERE ${usersTable.role} = 'investor')`.mapWith(Number),
      pendingInvestors: sql<number>`COUNT(*) FILTER (WHERE ${usersTable.role} = 'investor' AND ${usersTable.status} = 'pending')`.mapWith(Number),
      totalBrokers: sql<number>`COUNT(*) FILTER (WHERE ${usersTable.role} = 'broker')`.mapWith(Number),
      pendingBrokers: sql<number>`COUNT(*) FILTER (WHERE ${usersTable.role} = 'broker' AND ${usersTable.status} = 'pending')`.mapWith(Number),
      vipUsers: sql<number>`COUNT(*) FILTER (WHERE ${usersTable.membership} = 'vip')`.mapWith(Number),
      eliteUsers: sql<number>`COUNT(*) FILTER (WHERE ${usersTable.membership} = 'elite')`.mapWith(Number),
    })
    .from(usersTable);

  const [{ total: totalAccessRequests }] = await db.select({ total: count() }).from(accessRequestsTable);

  const [leadStats] = await db
    .select({
      total: count(),
      newLeads: sql<number>`COUNT(*) FILTER (WHERE ${sellerLeadsTable.status} = 'new')`.mapWith(Number),
    })
    .from(sellerLeadsTable);

  const [dealRoomStats] = await db
    .select({
      activeDealRooms: sql<number>`COUNT(*) FILTER (WHERE ${dealRoomsTable.status} = 'live')`.mapWith(Number),
      closedDealRooms: sql<number>`COUNT(*) FILTER (WHERE ${dealRoomsTable.status} = 'closed')`.mapWith(Number),
    })
    .from(dealRoomsTable);

  const [bidStats] = await db
    .select({
      total: count(),
      shortlisted: sql<number>`COUNT(*) FILTER (WHERE ${bidsTable.status} = 'shortlisted')`.mapWith(Number),
    })
    .from(bidsTable);

  res.json({
    totalDeals: dealStats.total,
    pendingDeals: dealStats.pending,
    approvedDeals: dealStats.approved,
    rejectedDeals: dealStats.rejected,
    totalInvestors: userStats.totalInvestors,
    pendingInvestors: userStats.pendingInvestors,
    totalBrokers: userStats.totalBrokers,
    pendingBrokers: userStats.pendingBrokers,
    totalAccessRequests,
    vipUsers: userStats.vipUsers,
    eliteUsers: userStats.eliteUsers,
    totalSellerLeads: leadStats.total,
    newSellerLeads: leadStats.newLeads,
    activeDealRooms: dealRoomStats.activeDealRooms,
    closedDealRooms: dealRoomStats.closedDealRooms,
    totalBidsSubmitted: bidStats.total,
    shortlistedBids: bidStats.shortlisted,
  });
});

export default router;
